export const tableGridColumns = '48px 2fr 2fr 2fr 64px 48px';
